<template>
  <div
    class="offcanvas offcanvas-end"
    tabindex="-1"
    id="offcanvasRight"
    aria-labelledby="offcanvasRightLabel"
  >
    <div class="offcanvas-header position-fixed w-100">
      <h5 id="offcanvasRightLabel"></h5>
      <button
        type="button"
        class="btn-close text-reset"
        data-bs-dismiss="offcanvas"
        aria-label="Close"
      ></button>
    </div>
    <div
      class="offcanvas-body d-flex flex-column justify-content-center"
      style="background-color: #f2efe6"
    >
      <div class="row w-100 h-100 d-flex align-items-center">
        <div
          v-for="(contact, index) in contacts"
          :key="index"
          class="col-md-3 col-sm-12 d-flex flex-column align-items-center text-center py-3"
        >
          <div class="col-md-8 col-sm-6 pb-3">
            <img
              :src="contact.image"
              :alt="contact.name"
              class="rounded-circle img-fluid h-auto"
            />
          </div>
          <h4 class="text-black">Contact {{ contact.name }}</h4>
          <div class="d-flex justify-content-center gap-2 w-75 py-2">
            <!-- <a :href="'mailto:' + contact.email">
              <img
                src="/img/ui-theme/email-icon-rev.svg"
                alt="Email"
                height="40"
              />
            </a> -->
            <a :href="'tel:' + contact.phone" class="d-lg-none">
              <img
                src="/img/ui-theme/phone-icon-rev.svg"
                alt="Contact"
                height="40"
              />
            </a>
          </div>
          <a :href="'tel:' + contact.phone" class="phone d-none d-lg-block">
            <h5>{{ contact.phone }}</h5>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OffCanvas',
  props: ['heading'],
  data() {
    return {
      contacts: [
        {
          name: '',
          image: '',
          email: '',
          phone: '',
        },
      ],
    }
  },
}
</script>

<style scoped>
.btn-theme-menu {
  width: 60%;
  background: #000;
  color: #fff;
  font-weight: 300;
  margin: auto;
}
.phone {
  color: #000;
  text-decoration: none;
}
</style>
